<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Accounting</h1>
    <p>Qtac can provide a general ledger report for journal entry. Does your company require an integration with an accounting provider?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="custom-check">
             <input type="checkbox" v-model="formData.accountingIntegration.isRequired">Yes, we require an integration with an accounting provider
            <span class="checkmark"></span>
        </label>
        Please provide the name of your accounting software provider
        <input 
            type="text" 
            id="accountingSoftwareProvider" 
            name="accountingSoftwareProvider" 
            placeholder="" 
            v-model="formData.accountingIntegration.softwareProvider" 
            :disabled="!accountingSoftwareProviderEnabled"
            required 
           >
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router';

const error = ref(null)
const route = useRoute();
const taskId = route.params.taskId;


const props = defineProps({
  formData: Object
})


const accountingSoftwareProviderEnabled = ref(!!props.formData.accountingIntegration.isRequired);

watch(
  () => props.formData.accountingIntegration.isRequired,
  (newVal) => {
    accountingSoftwareProviderEnabled.value = !!newVal;
    if (!newVal) {
      props.formData.accountingIntegration.softwareProvider = '';
    }
  }
);

const validateStep = () => {
  return true;
}

import { putPreDiscoveryChecklist } from '@/services/implementationmanagement.api';
const executeStep = async () => {


  var payload = {
    version: 1,
    jsonData: JSON.stringify(props.formData),
    schemaName: "PrediscoveryChecklist",
  }

  var response = await putPreDiscoveryChecklist(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }

  return true;
}




defineExpose({ validateStep, executeStep });

</script>